import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
}

/**
 * Container - Content wrapper with max-width and responsive padding
 * 
 * Centers content and provides consistent spacing across the application.
 * Uses the .container class from components.css which provides:
 * - Max-width: 1100px
 * - Responsive padding: 18px (mobile) → 24px (tablet) → 32px (desktop)
 * - Auto horizontal margins for centering
 */
export function Container({ children }: ContainerProps) {
  return <div className="container">{children}</div>;
}
